// Dni płatne w panelu (N.3). Lokalne liczenie jest ZAPASEM: kwotę i dni płatne rozstrzyga wycena
// z serwera (POST /api/price-quote, pole `chargeableDays`), a ten moduł działa, dopóki wycena nie
// wróciła albo gdy się nie udała. `dniPlatne` to lustro Login/backend/lib/pricing.js#computeChargeableDays,
// a zgodność pilnuje Login/backend/tests/dniPlatneLustra.test.js.
//
// `tabela` to `paid_days` z GET /api/rental-rules (wiersze od 1 do 14 dni, dłuższy wynajem to wiersz
// 14 plus każdy kolejny dzień), null = reguła domyślna: do 7 dni każdy dzień, 8 dni jak 7, dłużej
// o 2 dni mniej. Moduł jest czysty (test serwera wykonuje go poza Reactem), a tabelę firmy daje hook
// `utils/useTabelaDniPlatnych.js`.

const DNI_TABELI = 14;

export const WIERSZE_TABELI = Array.from({ length: DNI_TABELI }, (_, i) => i + 1);

const grosze = (x) => Math.round((Number(x) + Number.EPSILON) * 100) / 100;

export const dniPlatne = (dni, tabela = null) => {
  if (tabela) {
    if (dni <= 0) return 0;
    if (dni <= DNI_TABELI) return Number(tabela[dni]);
    return grosze(Number(tabela[DNI_TABELI]) + (dni - DNI_TABELI));
  }
  if (dni <= 7) return dni;
  if (dni === 8) return 7;
  return Math.max(0, dni - 2);
};

/**
 * Dni płatne zapisanej rezerwacji na umowie. Przy rezerwacji nie zapisuje się, czym ją policzono,
 * a tabela firmy działa tylko przy nowej wycenie, więc ustawienie tabeli nie może zmienić liczby dni
 * i stawki na dokumencie rezerwacji policzonej wcześniej. Dlatego reguła domyślna, chyba że `kwota`
 * zgadza się ze stawkami wyłącznie przy dniach z tabeli: taką rezerwację wyceniono już z tabelą,
 * a przy regule domyślnej umowa miałaby inną stawkę za dzień niż cennik. Kwotę niepasującą do żadnej
 * reguły (ceny dynamiczne, zestaw) serwer i tak rozkłada na wiersze umowy.
 */
export const dniPlatneZapisanej = (dni, tabela, kwota, stawki = []) => {
  const domyslne = dniPlatne(dni, null);
  if (!tabela) return domyslne;
  const zTabeli = dniPlatne(dni, tabela);
  // Do grosza na sztukę: serwer zaokrągla kwotę każdej sztuki osobno.
  const pasuje = (x) => Math.abs(stawki.reduce((suma, s) => suma + s * x, 0) - Number(kwota)) <= 0.01 * stawki.length;
  return pasuje(zTabeli) && !pasuje(domyslne) ? zTabeli : domyslne;
};

/** Dni płatne z aktualnej wyceny serwera, a bez niej `zapas` policzony lokalnie. */
export const dniPlatneZWyceny = (wycena, zapas) => {
  const zSerwera = wycena ? Number(wycena.chargeableDays) : NaN;
  return Number.isFinite(zSerwera) && zSerwera > 0 ? zSerwera : zapas;
};

/** Dni płatne na ekranie, po polsku z przecinkiem: tabela firmy dopuszcza ułamki (7,5). */
export const pokazDniPlatne = (dni) => (Number.isFinite(Number(dni)) ? String(grosze(dni)).replace('.', ',') : '');
